module.exports = __webpack_public_path__ + "de95be35.svg";


//////////////////
// WEBPACK FOOTER
// ./public/icons/search.svg
// module id = 2758
// module chunks = 15